import { render } from "./Templates.vue?vue&type=template&id=e672f034"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
script.render = render

export default script